import FeatureGates from '@atlaskit/feature-gate-js-client';
export const isSoftwareFormsEnabled = () => {
  if (FeatureGates.initializeCalled()) {
    return FeatureGates.getExperimentValue('forms_for_jsw_experiment', 'isEnabled', false, {
      fireExperimentExposure: false
    });
  }
  return false;
};